import HcClinicalRoster  from "./HcClinicalRoster";

export default HcClinicalRoster;